(() => {
  const roots = new WeakSet();

  const animationCSS = `
    @keyframes subtleBump {
      0%, 100% {
        transform: scale(1);
      }

      50% {
        transform: scale(1.04);
      }
    }

    .activator {
      background:linear-gradient(90deg,#f4a21a,#ffde00 50%,#f4a21a) !important;
      animation: subtleBump 2.5s ease-in-out infinite !important;
    }
  `;

  const addAnimation = (root) => {
    if (!root || !root.querySelector || root.querySelector('#chat-animation-style')) return;

    const style = document.createElement('style');
    style.id = 'chat-animation-style';
    style.textContent = animationCSS;

    if (root === document || root.nodeType === 9) {
      (document.head || document.documentElement).appendChild(style);
    } else {
      root.appendChild(style);
    }
  };

  const applyStyles = (root) => {
    if (!root || !root.querySelector) return;

    addAnimation(root);
    const label = root.querySelector('.activator__label');

if (label) {
  label.style.setProperty('font-weight', '900', 'important');
}

  };

  const watchRoot = (root) => {
    if (!root || roots.has(root)) return;

    roots.add(root);
    applyStyles(root);

    new MutationObserver(() => {
      applyStyles(root);

      if (root.querySelectorAll) {
        const children = root.querySelectorAll('*');

        for (let i = 0; i < children.length; i++) {
          if (children[i].shadowRoot) {
            watchRoot(children[i].shadowRoot);
          }
        }
      }
    }).observe(root, {
      childList: true,
      subtree: true,
    });

    if (root.querySelectorAll) {
      const children = root.querySelectorAll('*');

      for (let i = 0; i < children.length; i++) {
        if (children[i].shadowRoot) {
          watchRoot(children[i].shadowRoot);
        }
      }
    }
  };

  const setupChatHost = (host) => {
    if (!host) return;

    if (host.shadowRoot) {
      watchRoot(host.shadowRoot);
    }

    watchRoot(host);
    applyStyles(host);
  };

  const init = () => {
    addAnimation(document);

    const chatHosts = document.querySelectorAll(
      'shopify-chat, #shopify-chat, .chatbot-container-sdk'
    );

    chatHosts.forEach(setupChatHost);

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-chat').then(() => {
        const chat = document.querySelector(
          'shopify-chat, #shopify-chat, .chatbot-container-sdk'
        );

        if (chat) setupChatHost(chat);
      });
    }

    document.addEventListener(
      'click',
      (e) => {
        const target = e.target;

        if (
          target &&
          (
            target.tagName === 'SHOPIFY-CHAT' ||
            (
              target.closest &&
              target.closest(
                'shopify-chat, #shopify-chat, .chatbot-container-sdk'
              )
            )
          )
        ) {
          setTimeout(() => {
            const chat = document.querySelector(
              'shopify-chat, #shopify-chat, .chatbot-container-sdk'
            );

            if (chat) setupChatHost(chat);
          }, 100);
        }
      },
      { passive: true }
    );

    const bodyObserver = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const nodes = mutations[i].addedNodes;

        for (let j = 0; j < nodes.length; j++) {
          const node = nodes[j];

          if (node.nodeType === 1) {
            if (
              node.tagName === 'SHOPIFY-CHAT' ||
              node.id === 'shopify-chat' ||
              node.classList?.contains('chatbot-container-sdk')
            ) {
              setupChatHost(node);
              bodyObserver.disconnect();
            } else if (node.querySelector) {
              const chat = node.querySelector(
                'shopify-chat, #shopify-chat, .chatbot-container-sdk'
              );

              if (chat) {
                setupChatHost(chat);
                bodyObserver.disconnect();
              }
            }
          }
        }
      }
    });

    bodyObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: false,
    });

    setTimeout(() => bodyObserver.disconnect(), 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
